export default __webpack_public_path__ + "static/5-general-sibling-189b6ae0f49b27272a79f7a9e40e240d.png";